import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MaintenanceService } from '@shared/service/maintenance.service';

/**
 * Flips the app into maintenance mode as soon as any request comes back with a
 * `503 Service Unavailable`, so the backend can lock the client even without a
 * socket message. The original error is rethrown untouched.
 */
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private readonly _maintenance = inject(MaintenanceService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse && err.status === 503) {
          this._maintenance.start();
        }
        return throwError(() => err);
      })
    );
  }
}
